import React, { useState } from 'react';
import WizardModal from '../../components/modal/WizardModal';
import MixpanelService from '../../utils/mixpanelService';
import { WIZARD_CLOSE, WIZARD_OPEN } from '../../utils/mixpanelEvents';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import rocket from '../../assets/img/rocket.svg';
import OpenWizardButton from 'components/buttons/OpenWizardButton';
import i18n from '../../i18n';
import Card from 'react-bootstrap/Card';
import { useHistory } from 'react-router';
import Button from 'react-bootstrap/Button';

interface ReadyToMockCardProps {
  compact: boolean; //If true, compact banner is shown
}

const ReadyToMockCard = (props: ReadyToMockCardProps) => {
  const [showWizard, setShowWizard] = useState(false);
  const history = useHistory();

  const onOpenWizardClick = () => {
    setShowWizard(true);
    MixpanelService.track(WIZARD_OPEN('Learn More Page'));
  };

  const onCloseWizard = (stepNumber: number) => {
    setShowWizard(false);
  };

  const getDoneButton = () => {
    return (
      <Button
        onClick={() => {
          history.push('/mock-services');
          MixpanelService.track(WIZARD_CLOSE(6));
        }}
      >
        {i18n.t('wizard:details.created.openMyMockService')}
      </Button>
    );
  };

  return (
    <>
      {showWizard === true && <WizardModal doneButton={getDoneButton()} onClose={onCloseWizard} />}
      <Card className={'p-7'}>
        <Row>
          <Col lg="2">
            <h1
              className={'text-uppercase'}
              dangerouslySetInnerHTML={{ __html: i18n.t('learnMore:readyToMock.readyToCreateMs') }}
            ></h1>
          </Col>
          <Col lg="10">
            <div className="float-left mr-7" style={{ width: '18%', height: '100%' }}>
              <img src={rocket} className={'img-fluid'} alt="Rocket Illustration" />
            </div>
            <div>
              <h2>{i18n.t('learnMore:readyToMock.createFirstMs')}</h2>
              <p>{i18n.t('learnMore:readyToMock.paragraph1')}</p>
              <p className={'mb-6'}>{i18n.t('learnMore:readyToMock.paragraph2')}</p>
              <OpenWizardButton size={'lg'} variant={'primary'} onClick={onOpenWizardClick} />
            </div>
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default ReadyToMockCard;
